import { useEffect, useState } from 'react';
import PlayerTable from './PlayerTable';
import AccountsSelect from './AccountsSelect';
import PaginationControls from './PaginationControls';
import SearchBar from '@/common/SearchBar';
import Checkbox from '@/common/Checkbox';
import { useTourBag } from './useTourBag';
import { ActivePlayerDB } from '@/db/repositories';
import { getUser } from '@/library/UserSessionHelper';
import { IModuleSettings } from '@/library/ModuleSettingsHelper';
import { isMobileResolution } from '@/utils';
import styles from './TourBag.module.scss';

function TourBag() {
  const [loading, setLoading] = useState(true);
  const [isActiveModule, setIsActiveModule] = useState(false);
  const { setNameQuery, accounts, selectedAccount, handleSelectedAccount, showMyPlayers, handleShowMyPlayers, players, ...rest } = useTourBag();

  useEffect(() => {
    const fetchModuleSettings = async () => {
      await ActivePlayerDB.clear(); // Clear any active player when landing in this page
      const user = await getUser();
      const moduleSettings = user?.moduleSettings as IModuleSettings;
      setIsActiveModule(Boolean(moduleSettings?.tourBag));
      setLoading(false);
    };
    fetchModuleSettings();
  }, []);

  if (loading || !players || !accounts) return <>Loading...</>;

  return (
    <div className={styles.container}>
      {!isActiveModule && <div className={styles.noPermission}>You currently don&apos;t have access to this module, please contact your Admin regarding permissions.</div>}
      {isActiveModule && (
        <>
          <div className={styles.toolbar}>
            <div>
              <SearchBar placeholder="Search Players" onSearch={setNameQuery} classNames={styles.searchBar} />
              {isMobileResolution && <Checkbox label="My Players" checked={showMyPlayers} onClick={async () => await handleShowMyPlayers()} />}
              {!isMobileResolution && (
                <>
                  <Checkbox label="My Players" checked={showMyPlayers} onClick={async () => await handleShowMyPlayers()} />
                  <AccountsSelect accounts={accounts} defaultValue={selectedAccount} handleSelectedAccount={handleSelectedAccount} className={styles.accountsSelect} />
                </>
              )}
            </div>
            {!isMobileResolution && <PaginationControls {...rest} />}
          </div>
          <PlayerTable players={players} />
          {isMobileResolution && <PaginationControls {...rest} />}
        </>
      )}
    </div>
  );
}

export default TourBag;
